import FormattedMessage from 'I18n/components/FormattedMessage';
import { getAssistantId } from 'chatspot-core/assistants/getAssistantId';
import { BREEZE_COPILOT, SALES_COPILOT } from 'chatspot-core/types/CopilotAssistantTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export const BREEZE_ASSISTANT_NAME = 'Breeze Assistant';
// TODO - remove this function and use a constant when rebranding is complete
// Part of: https://git.hubteam.com/HubSpot/copilot-issues/issues/455
export const getBreezeCopilotAssistant = isUngatedForBreezeRebrand => {
  return {
    type: BREEZE_COPILOT,
    name: isUngatedForBreezeRebrand ? BREEZE_ASSISTANT_NAME : 'Copilot',
    iconUrl: undefined,
    id: undefined,
    welcomeMessage: isUngatedForBreezeRebrand ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "threads.emptyState.title"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "threads.emptyState.titleV2"
    })
  };
};
export const SALES_COPILOT_ASSISTANT = {
  type: SALES_COPILOT,
  name: 'Sales Copilot',
  iconUrl: undefined,
  id: getAssistantId(),
  welcomeMessage: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "threads.salesCopilotEmptyState.subheading"
  })
};